import {
  TiptapBase,
  Heading,
  BulletList,
  OrderedList,
  Bold,
  Italic,
  Strike,
  History,
  FontFamily,
  Link,
  Underline,
  TextAlign,
  ListItem,
  TextStyle,
  Placeholder,
} from '@/js/util/tiptap/extensions';

import {
  FontFamilyHandlers,
  HeadingLevelHandlers,
  HorizontalRuleHandlers,
  LinksHandlers,
  ListsHandlers,
  TextAlignmentHandlers,
  TextFormattingHandlers,
  PresetHandlers,
  HistoryHandlers,
} from '@/js/util/tiptap/handlers';

const DEFAULT_PLACEHOLDER = 'Please add design rationale. This is your pitch, make it compelling!';

export default class DesignerNotesConfig {
  // An editor may set its own (data-tiptap-editor-placeholder-value), as board_show_v2's does.
  constructor({ placeholder } = {}) {
    this.placeholder = placeholder || DEFAULT_PLACEHOLDER;
  }

  get extensions() {
    return [
      ...TiptapBase,
      ...Heading,
      ...BulletList,
      ...OrderedList,
      ...Bold,
      ...Italic,
      ...Strike,
      ...History,
      ...FontFamily,
      ...Link,
      ...Underline,
      ...TextAlign,
      ...ListItem,
      ...TextStyle,
      Placeholder[0].configure({ placeholder: this.placeholder }),
    ];
  }

  get handlers() {
    return {
      ...FontFamilyHandlers,
      ...HeadingLevelHandlers,
      ...HorizontalRuleHandlers,
      ...LinksHandlers,
      ...ListsHandlers,
      ...TextAlignmentHandlers,
      ...TextFormattingHandlers,
      ...PresetHandlers,
      ...HistoryHandlers,
    };
  }
}
